import { render, staticRenderFns } from "./WhatCanISellBlock.vue?vue&type=template&id=dbff5d4a&scoped=true&"
import script from "./WhatCanISellBlock.vue?vue&type=script&lang=js&"
export * from "./WhatCanISellBlock.vue?vue&type=script&lang=js&"
import style0 from "./WhatCanISellBlock.vue?vue&type=style&index=0&id=dbff5d4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbff5d4a",
  null
  
)

export default component.exports